import { render } from "./HeroiconsSolidPaperAirplane.vue?vue&type=template&id=2184db46"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPaperAirplane.vue"]])

export default __exports__